/* Generated by restful-react */

import React from 'react'
import {
  Get,
  GetProps,
  useGet,
  UseGetProps,
  Mutate,
  MutateProps,
  useMutate,
  UseMutateProps,
  Poll,
  PollProps,
} from 'restful-react'

export const SPEC_VERSION = 'v9'
export interface NormFileGeneratorStatusesResponse {
  normFileGeneratorStatuses?: NormFileGeneratorStatus[]
  totalCount?: number
}

export interface NormFileGeneratorStatusFilters {
  googleSheetsUrl?: string
  userId?: number
  currentUser?: boolean
  statuses?: string[]
}

export interface NormFileGeneratorStatus {
  id: number
  createdAt: string
  googleSheetsUrl: string
  status: string
  createdByUser: {
    id?: number
    firstName?: string
    lastName?: string
  }
  requestForProposalId?: number | null
  shipper: string | null
  rfpName: string | null
  dueDate?: string | null
  auditWorkspace: boolean
  workspace?: string | null
  rfpPricingRound: number
}

export interface GetNormFileGeneratorStatusesQueryParams {
  filters?: NormFileGeneratorStatusFilters
  pageCount?: number
}

export type GetNormFileGeneratorStatusesProps = Omit<
  GetProps<
    NormFileGeneratorStatusesResponse,
    unknown,
    GetNormFileGeneratorStatusesQueryParams,
    void
  >,
  'path'
>

/**
 * Get all norm file generator statuses
 */
export const GetNormFileGeneratorStatuses = (props: GetNormFileGeneratorStatusesProps) => (
  <Get<NormFileGeneratorStatusesResponse, unknown, GetNormFileGeneratorStatusesQueryParams, void>
    path='/v9/norm_file_generator_statuses'
    {...props}
  />
)

export type PollGetNormFileGeneratorStatusesProps = Omit<
  PollProps<
    NormFileGeneratorStatusesResponse,
    unknown,
    GetNormFileGeneratorStatusesQueryParams,
    void
  >,
  'path'
>

// Get all norm file generator statuses (long polling)
export const PollGetNormFileGeneratorStatuses = (props: PollGetNormFileGeneratorStatusesProps) => (
  <Poll<NormFileGeneratorStatusesResponse, unknown, GetNormFileGeneratorStatusesQueryParams, void>
    path='/v9/norm_file_generator_statuses'
    {...props}
  />
)

export type UseGetNormFileGeneratorStatusesProps = Omit<
  UseGetProps<
    NormFileGeneratorStatusesResponse,
    unknown,
    GetNormFileGeneratorStatusesQueryParams,
    void
  >,
  'path'
>

/**
 * Get all norm file generator statuses
 */
export const useGetNormFileGeneratorStatuses = (props: UseGetNormFileGeneratorStatusesProps) =>
  useGet<NormFileGeneratorStatusesResponse, unknown, GetNormFileGeneratorStatusesQueryParams, void>(
    `/v9/norm_file_generator_statuses`,
    props
  )

export type GetWorkStatusResponse = {
  total?: number | null
  pending?: number | null
  success?: number | null
  failure?: number | null
  error?: number | null
}

export interface GetWorkStatusQueryParams {
  id: number
}

export type GetWorkStatusProps = Omit<
  GetProps<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >,
  'path'
>

/**
 * Get work status
 */
export const GetWorkStatus = (props: GetWorkStatusProps) => (
  <Get<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >
    path='/v9/norm_file_generator_statuses/work_status'
    {...props}
  />
)

export type UseGetWorkStatusProps = Omit<
  UseGetProps<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >,
  'path'
>

/**
 * Get work status
 */
export const useGetWorkStatus = (props: UseGetWorkStatusProps) =>
  useGet<
    GetWorkStatusResponse,
    {
      errors?: string[]
    },
    GetWorkStatusQueryParams,
    void
  >(`/v9/norm_file_generator_statuses/work_status`, props)

export interface RerunFailedLanesRequestBody {
  id?: number
}

export type RerunFailedLanesProps = Omit<
  MutateProps<
    void,
    {
      errors?: string[]
    },
    void,
    RerunFailedLanesRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Rerun failed lanes
 */
export const RerunFailedLanes = (props: RerunFailedLanesProps) => (
  <Mutate<
    void,
    {
      errors?: string[]
    },
    void,
    RerunFailedLanesRequestBody,
    void
  >
    verb='POST'
    path='/v9/norm_file_generator_statuses/rerun_failed'
    {...props}
  />
)

export type UseRerunFailedLanesProps = Omit<
  UseMutateProps<
    void,
    {
      errors?: string[]
    },
    void,
    RerunFailedLanesRequestBody,
    void
  >,
  'path' | 'verb'
>

/**
 * Rerun failed lanes
 */
export const useRerunFailedLanes = (props: UseRerunFailedLanesProps) =>
  useMutate<
    void,
    {
      errors?: string[]
    },
    void,
    RerunFailedLanesRequestBody,
    void
  >('POST', `/v9/norm_file_generator_statuses/rerun_failed`, props)
